import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import Banner from './Banner'
import Editable from '../inspector/Editable'
import { usePrefs } from '@/state/prefs'
import { useScrolled } from '@/state/useScrolled'
import { bannerGroups, disclosureOptions } from '../home/options'
import { useIsHome } from '@/state/useIsHome'

/** The site banner; on the home page it carries a design note. */
export function SiteBanner() {
  const isHome = useIsHome()
  const navigate = useNavigate()
  const { prefs, set } = usePrefs()
  const scrolled = useScrolled()
  // The banner's height, so a header below a banner that stays can sit under it.
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const root = document.documentElement
    const measure = () => root.style.setProperty('--mds-banner-height', `${el.offsetHeight}px`)
    measure()
    if (typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver(measure)
    observer.observe(el)
    return () => observer.disconnect()
  }, [])
  return (
    <div ref={ref} className="mds-banner-wrap">
      <Editable
        label="Banner"
        optionsLabel="Disclosure"
        value={prefs.bannerMode}
        options={disclosureOptions}
        onChange={(value) => set('bannerMode', value as typeof prefs.bannerMode)}
        more={bannerGroups(prefs, set)}
        token="banner"
        pin="inside-top-right"
        className="mds-banner-edit mds-editable--region"
        enabled={isHome && !scrolled}
      >
        <Banner
          onNavigate={(href) => {
            navigate(href)
          }}
        />
      </Editable>
    </div>
  )
}
